import React, { useEffect, useState } from "react";
import AppButton from "../../sharedcomponents/Buttons/AppButton/AppButton";
import { useAssetsPage } from "../../../store/AssetsProvider";
import { buildAssetPayload, buildQrDataUrl, downloadAssetQr } from "../core/qr";
import { AssetQrFieldsPicker } from "./AssetQrFields";

export default function AssetQrModal() {
  const { activeAsset, qrFields } = useAssetsPage();
  const [dataUrl, setDataUrl] = useState<string>("");

  const payload = activeAsset ? buildAssetPayload(activeAsset, qrFields) : "";

  useEffect(() => {
    let cancelled = false;
    if (payload) {
      buildQrDataUrl(payload, 240).then((url) => {
        if (!cancelled) setDataUrl(url);
      });
    } else {
      setDataUrl("");
    }
    return () => {
      cancelled = true;
    };
  }, [payload]);

  return (
    <div className="modal fade" id="kt_modal_asset_qr" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered mw-600px">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="asset-modal-title">
              QR Code
              <small className="text-muted">{activeAsset?.assetNo}</small>
            </h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body asset-qr-modal">
            {dataUrl ? (
              <img src={dataUrl} alt="Asset QR code" className="asset-qr-image" />
            ) : (
              <div className="asset-qr-image asset-qr-image--placeholder" />
            )}
            <pre className="asset-qr-payload">{payload}</pre>
            <details className="asset-qr-fields-toggle">
              <summary>
                <i className="fa-solid fa-sliders me-2"></i>
                Choose what the QR code contains
              </summary>
              <AssetQrFieldsPicker />
            </details>
            <AppButton
              btnType="primary"
              width="180px"
              onClick={() => activeAsset && downloadAssetQr(activeAsset, qrFields)}
            >
              <i className="fa-solid fa-download me-2"></i>
              Download PNG
            </AppButton>
          </div>
        </div>
      </div>
    </div>
  );
}
